import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

/**
 * Hook to fetch count of unregistered error devices
 * Server-side filtering: Version >= 600, heartbeat within past 2 days, not registered
 */
const useUnregisteredDevicesCount = () => {
  return useQuery<number>({
    queryKey: ["errorDevicesCount"],
    queryFn: async () => {
      const { count } = await adminApiClient.getUnregisteredDevicesCount();
      return count;
    },
  });
};

export default useUnregisteredDevicesCount;
